<template>
<div>
	<h3>Asignación de EA de BCEI</h3>
	<Doughnut id="by_prt_ac"
		:onClick="(ev,arr)=>openModal(ev,arr,'by_prt_ac')"
		:data.sync="dataBar.datasets[0].data"
		:labels="dataBar.labels"
		:colors="colors"/>

	<v-dialog persistent v-model="dialog" width="90%">
		<v-card class="pa-20">
		<!-- :ex_permission="17" -->
			<v-layout>
				<v-flex md6>
					<h3>{{title}}</h3>
				</v-flex>
				<v-flex md6 style="text-align:right">
					<export-ex  name="critical_asset" :extra_filter="filter"/>
				</v-flex>
			</v-layout>
			<critical_asset :no_title="true" :pre_name="pre_name"/>
			<div class="textAlignCenter">
				<v-btn color="primary" @click="dialog = false">
					<span>Cerrar</span>
				</v-btn>
			</div>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
import critical_asset from '@/components/tables/critical_asset.vue';
import Doughnut from '@/components/graphs/Doughnut.vue';
const get_data = (list, key) => list.map(obj => obj[key]);

export default {
	props:{
		items:{
			default: () => {return{with_ea:{},without_ea:{}}}
		}
	},
	components:{critical_asset, Doughnut},
	data() {
		return {
			modal_name:null,
			pre_name: 'by_prt_ac',
			rq_name: 'join/critical_asset/detail/functional_location',
			title: '',
			dialog: false,
			colors:['#C1DF8E','#66A034','#5872C2'],
			pre_filter:{is_deleted: false},
		}
	},
	computed:{
		alter_name(){ return `${this.pre_name}-${this.rq_name}`},
    dataBar() {
      const dataBar = {labels: ['BCEI con EA','BCEI sin EA'], datasets: []};
      const {with_ea,without_ea} = this.items;
      const g_t = (key) => get_data([with_ea,without_ea],key);

      dataBar.datasets = [{
				label: 'Vigente',
				data: g_t('total'),
			}];
      return dataBar;
    },
    requestStatus() {return this.$store.getters.requestStatus},
    myRequestStatus() {return this.requestStatus.find(f => f.name === `${this.alter_name}/a/all`)},
    filter() {
      if (!this.myRequestStatus) return null;
      return this.myRequestStatus.filter;
    },
	},

	methods:{
		resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    },
    openModal(ev, array) {
			if (!array[0]) return;
			const label = array[0]._model.label;
			if (this.myRequestStatus) this.resetRqStatus();
			this.filter.f__with_ea = label == 'Activos críticos con EA';
			const filter = {...this.filter};
			Object.keys(filter).forEach(k => [undefined,null].includes(filter[k]) && (delete filter[k]));
			Object.assign(filter,this.pre_filter);
			this.requests.gets[`${this.alter_name}/a/all`](filter);
      this.title = `EA - ${label}`;
			this.dialog = true;
    },
	}
};
</script>
